<div class="ar-voice-selector">
  <h3>Voice</h3>
  <p>Choose what sort of voice your character will have.</p>
  <!-- <div class="ar-voice-filter">
    <span>Sort available voices</span>
    <button class="ar-filter-button">▼</button>
  </div>
  <div class="ar-voice-categories">
    <label><input type="checkbox" checked> All</label>
    <label><input type="checkbox"> Young</label>
    <label><input type="checkbox"> Middle age</label>
    <label><input type="checkbox"> Old</label>
    <label><input type="checkbox"> British</label>
    <label><input type="checkbox"> American</label>
    <label><input type="checkbox"> Irish</label>
    <label><input type="checkbox"> English-Swedish</label>
    <label><input type="checkbox"> English-Italian</label>
    <label><input type="checkbox"> Australian</label>
    <label><input type="checkbox"> African</label>
    <label><input type="checkbox"> Indian</label>
  </div> -->
  <div class="ar-voice-groups">
    <div class="ar-voice-group">
      <!-- <h4>Male</h4> -->
      <div class="ar-voice-buttons">
        <button *ngFor="let voice of voices" 
                [class.selected]="voice.id === selectedVoice.id"
                (click)="selectVoice(voice)">
          {{ voice.name }}
        </button>
      </div>
    </div>
    <!-- <div class="ar-voice-group">
      <h4>Female</h4>
      <div class="ar-voice-buttons">
        <button *ngFor="let voice of voices" 
                [class.selected]="voice.id === selectedVoice.id"
                (click)="selectVoice(voice)">
          {{ voice.name }}
        </button>
      </div>
    </div>
  </div> -->
</div>